var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8767 1.91406H6.45298C3.53607 1.91406 1.02148 4.27848 1.02148 7.19681V22.5662C1.02148 25.6489 3.37032 27.9141 6.45298 27.9141H17.7693C20.6877 27.9141 23.0535 25.4846 23.0535 22.5662V9.3884L15.8767 1.91406Z",
    fill: "none",
    stroke: "#B7B9B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5044 1.89844V6.01952C15.5044 8.03119 17.1321 9.66319 19.1438 9.66744C21.0081 9.67169 22.9164 9.6731 23.0453 9.6646",
    stroke: "#B7B9B3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7793 12.8281C12.7793 12.2758 12.3316 11.8281 11.7793 11.8281C11.227 11.8281 10.7793 12.2758 10.7793 12.8281V15.2985H8.30957C7.75729 15.2985 7.30957 15.7463 7.30957 16.2985C7.30957 16.8508 7.75729 17.2985 8.30957 17.2985H10.7793V19.7712C10.7793 20.3235 11.227 20.7712 11.7793 20.7712C12.3316 20.7712 12.7793 20.3235 12.7793 19.7712V17.2985H15.2527C15.8049 17.2985 16.2527 16.8508 16.2527 16.2985C16.2527 15.7463 15.8049 15.2985 15.2527 15.2985H12.7793V12.8281Z",
    fill: "#E0E1E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlus);
export default __webpack_public_path__ + "static/media/PaperPlus.0cee91fdca5206bdf8bcabce197b762a.svg";
export { ForwardRef as ReactComponent };